module.exports = __webpack_public_path__ + "img/jakeem_grant.b2979c0e.png";